import welcomeSvg from '../../assets/images/welcome.svg';

const TOUR_REFERAL_CONTENT = [
  {
    content: <img src={welcomeSvg} alt="step" style={{ marginRight: '8px' }} />,
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Search & Filter',
    content: 'Use criteria based filter and search to view referred merchant’s activation status',
    placement: 'right',
    target: '.ebz-filters-btn'
  },
  {
    title: 'Export',
    content: 'Export customized data for tracking the merchant’s activation status',
    placement: 'bottom',
    target: '.export-btn'
  },
  {
    title: 'Create Lead',
    content: 'Add prospective leads and schedule a demo for them',
    placement: 'bottom',
    target: '.create-lead'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

const PRODUCT_APP_TYPE = [
  {
    label: 'Payment Gateway',
    value: 'pay_easebuzz_allowed'
  },
  {
    label: 'Payment Link',
    value: 'easepay_allowed'
  },
  {
    label: 'Form & Feesbuzz',
    value: 'edu_allowed'
  },
  {
    label: 'WIRE',
    value: 'wire_allowed'
  }
];

export { TOUR_REFERAL_CONTENT, PRODUCT_APP_TYPE };
